import { ExternalLink } from "lucide-react";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import AdminSidebar from "./AdminSidebar";
import AdminRouteGuard from "./AdminRouteGuard";

interface Props {
  title?: string;
  description?: string;
  publicHref?: string;
  publicLabel?: string;
  children: React.ReactNode;
}

const AdminLayout = ({ title, description, publicHref, publicLabel, children }: Props) => {
  return (
    <AdminRouteGuard>
      <SidebarProvider>
        <div className="flex min-h-screen w-full bg-muted/30">
          <AdminSidebar />
          <div className="flex min-w-0 flex-1 flex-col">
            <header className="sticky top-0 z-10 flex flex-col gap-1 border-b border-border bg-background px-4 py-2.5">
              <div className="flex items-center gap-3">
                <SidebarTrigger />
                {title ? (
                  <h1 className="truncate font-headline text-lg text-foreground">{title}</h1>
                ) : null}
                {publicHref ? (
                  <a
                    href={publicHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ml-auto inline-flex items-center gap-1 text-xs text-accent hover:text-accent/80"
                  >
                    <ExternalLink className="h-3.5 w-3.5" />
                    {publicLabel ?? "View on website"}
                  </a>
                ) : null}
              </div>
              {description ? (
                <p className="pl-9 text-[12px] text-muted-foreground">{description}</p>
              ) : null}
            </header>
            <main className="flex-1 overflow-x-hidden p-4 md:p-8">{children}</main>
          </div>
        </div>
      </SidebarProvider>
    </AdminRouteGuard>
  );
};

export default AdminLayout;
